export default (params) => ({
  trigger: {
    name: 'product_type_section.show_collection',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'color_collection',
          'upsell_collection',
        ],
      },
    },
    event: {
      name: 'show_content',
    },
    nonInt: true,
  },
});
